import React from 'react';

import { Link } from 'react-router-dom';

const ThankYouDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
          
            <div className="col-md-12">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  
                  <div className="details">
                    <h4>
                    Thank You Choosing Our Service
                    </h4>
                    <p>
                    Your Submission Is Successfully Submitted
                    </p>
                   
                    
                    <h4>Very Soon We Contact With You , Have a Wounderful Day</h4>
                    <br/>
                    <div className="details">
                    <Link className="btn btn-base border-radius-5" to="/">
                    Back To Home
                    </Link>
                  </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default ThankYouDetails;
